import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	Button,
} from '@chakra-ui/react'
import { InputText, Form } from '../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../helpers';




function Edit({ meCloseEdit, loadList, rs }) {
	const [formData, setFormData] = useState({
		server_ip: rs.server_ip,
		id: rs.id
	});
	const FormSchema = Yup.object().shape({
		server_ip: Yup.string().required('Required'),
	});

	useEffect(() => {
		if (rs) {
			setFormData({
				server_ip: rs.server_ip,
				id: rs.id
			});
		}
	}, [rs]);



	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {
		let data = values
		const config = {
			channel_config: data.channel_config

		}
		data.config = config;

		try {
			const url = `${process.env.REACT_APP_API_URL}/customer/update`;
			const response = await fetchWrapper.post(url, data)
			toast(`Record has been updated `, {
				type: "info"
			});
			
		} catch (error) {

		}

		loadList()
		meCloseEdit();
	
	}







	return (


		<Form
			enableReinitialize
			validationSchema={FormSchema}
			initialValues={formData}
			onSubmit={onSubmit}
		>


			<Box mb="10px">
				<InputText name="server_ip" title="Server IP" placeholder="Please Enter 127.0.0.1" />
			</Box>


			<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
				mb={4}

				type='submit'
			>
				Update Server IP
			</Button>
		</Form>


	)
}

export default Edit;